import { HttpClient, } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Tag } from '../models/Tag';

@Injectable({ providedIn: 'root' })
export class TagService {
  constructor(private http: HttpClient) { }

  getAllWithInfo(): Observable<Tag[]> {
    return this.http.get<Tag[]>('api/tag');
  }

  getAllNames(): Observable<string[]> {
    return this.http.get<string[]>('api/tag/names')
  }

  getTagFilter(value: string): Observable<string[]> {
    return this.http.get<any>(`api/tag/filter/${value}`);
  }

  createTag(value: string): Observable<any> {
    return this.http.post(`api/tag/${value}`, null, { observe: 'response' });
  }

  deleteTag(id: string): Observable<any> {
    return this.http.delete(`api/tag/${id}`, { observe: 'response' });
  }
}

